// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function getWithLazyDefault(opt, getDefault) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  } else {
    return Curry._1(getDefault, /* () */0);
  }
}

exports.getWithLazyDefault = getWithLazyDefault;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../belt-holes/src/BeltHoles_Option.bs.js
// module id = 1247
// module chunks = 0